module.exports = __webpack_public_path__ + "img/retro3.7513b29e.png";